import { Stack } from '@mui/material';
import { MouseEvent, useMemo } from 'react';
import { FilterPreferenceRecognizedLists } from '../../../../../services/modules/userContextPreferences/userContextPreferences.types';
import {
  FilterOptionV3,
  FilterProps,
  PossibleFilters,
} from '../../../../Crud/filters/sharedBetweenFilters/types';
import useWidth from '../../../../Hooks/useWidth';
import FilterFactory from '../../../factories/filter-factory';
import SelectedCreatorChipList from './SelectedCreatorList';
import SelectedFilterChip from './SelectedFilterChip';

export interface SelectedFilterListProps {
  wrap?: boolean;
  filters: (FilterOptionV3 & { hasValue: boolean })[];
  onClick: (event: MouseEvent<HTMLElement>, filter: FilterProps) => void;
  list: FilterPreferenceRecognizedLists;
}

const SelectedFilterList = ({ wrap = false, filters, onClick, list }: SelectedFilterListProps) => {
  const { smallWidth } = useWidth();

  const filteredMemoizedList: FilterOptionV3[] = useMemo(
    () => filters.filter((filter) => !filter.fixed && filter.hasValue),
    [filters],
  );

  const filterFactory = new FilterFactory();

  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        flexWrap: !smallWidth || wrap ? 'wrap' : 'nowrap',
      }}
    >
      {filteredMemoizedList.map((filter) => {
        const factory = filterFactory.getFactory(filter);

        if (filter.type === PossibleFilters.OPTIONS_SELECTOR_CREATOR) {
          return <SelectedCreatorChipList key={filter.title} filter={filter} list={list} />;
        }

        return (
          <SelectedFilterChip
            key={filter.title}
            filter={filter}
            factory={factory}
            onClick={onClick}
          />
        );
      })}
    </Stack>
  );
};

export default SelectedFilterList;
